import React, { useState, useMemo } from 'react';
import ReddyLayout from '../components/home/ReddyLayout';
import IconImg from '../components/home/IconImg';
import CategoryTabs from '../components/casino/CategoryTabs';
import SubTabs from '../components/casino/SubTabs';
import GameGrid from '../components/casino/GameGrid';
import { CASINO_CATEGORIES, CASINO_MARQUEE } from '../data/casinoData';
import { EVT, ICON_PH } from '../data/homeData';

/* Pixel-perfect Casino page (app-casino) inside the shared ReddyLayout shell.
   Two React-controlled tab levels: L1 category (fancy-subtabs) switches the L2
   sub-tab set (new_icasino_tabs), which switches the game grid (csn_div). The
   search box cosmetically filters the visible grid by game name. */
export default function ReddyCasinoPage() {
  const [activeCat, setActiveCat] = useState(0);
  const [activeSubs, setActiveSubs] = useState({}); // { [catIdx]: subIdx }
  const [searchQ, setSearchQ] = useState('');

  const cat = CASINO_CATEGORIES[activeCat];
  const subIdx = activeSubs[activeCat] || 0;
  const sub = cat.subtabs[subIdx] || cat.subtabs[0];

  const games = useMemo(() => {
    const q = searchQ.trim().toLowerCase();
    return q ? sub.games.filter((g) => g.name.toLowerCase().includes(q)) : sub.games;
  }, [sub, searchQ]);

  return (
    <ReddyLayout>
      <section className="section listing_page">
        <div className="row">
          {/* app-upcoming — commentary marquee */}
          <div className="col-12 d-flex">
            <div className="commentary marquee">
              <img src="/images/reddy/commentary.png" alt=""
                   onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = ICON_PH; }} />
              <span>{CASINO_MARQUEE}</span>
            </div>
          </div>

          <div className="col-lg-12 listing_page_12">
            <div className="middle-page-content home-page">
              {/* app-casino */}
              <div className="card-body card-content p-0">
                <div className="bet-table-header">
                  <div className="row align-items-center">
                    <div className="col-md-4">
                      <span className="list-sport-title">
                        <IconImg className="img-fluid game-icon-img" src={`${EVT}/menu-99998.png`} /> Casino
                      </span>
                    </div>
                    <div className="casino_searchbar">
                      <div className="input-group">
                        <input
                          type="text"
                          placeholder="Search Games..."
                          value={searchQ}
                          onChange={(e) => setSearchQ(e.target.value)}
                          autoComplete="off"
                        />
                        <span className="input-group-text"><i className="bi bi-search" /></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bet-table-body">
                <div className="home-products-container mt-1">
                  <div className="row row5">
                    <div className="col-md-12">
                      {/* LEVEL-1 category tabs → (children) LEVEL-2 sub-tabs → (children) game grid.
                          Nesting keeps each tab-content inside its .casino_tabs_ul tabset. */}
                      <CategoryTabs
                        categories={CASINO_CATEGORIES}
                        active={activeCat}
                        onChange={(i) => { setActiveCat(i); setSearchQ(''); }}
                      >
                        <SubTabs
                          subtabs={cat.subtabs}
                          active={subIdx}
                          onChange={(i) => setActiveSubs((s) => ({ ...s, [activeCat]: i }))}
                        >
                          {games.length === 0
                            ? <div className="casino-empty">No games found for “{searchQ}”.</div>
                            : <GameGrid games={games} />}
                        </SubTabs>
                      </CategoryTabs>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </ReddyLayout>
  );
}
